import { roleIsAtLeast, type Role } from "@event-planner/shared";

export function toRole(role: string | null | undefined): Role | null {
  if (
    role === "admin" ||
    role === "organizer" ||
    role === "internal" ||
    role === "invitee" ||
    role === "companion"
  ) {
    return role;
  }
  return null;
}

export function canViewInternalNotes(role: string | null | undefined): boolean {
  const parsed = toRole(role);
  return parsed ? roleIsAtLeast(parsed, "internal") : false;
}

export function canEditInternalNotes(role: string | null | undefined): boolean {
  const parsed = toRole(role);
  return parsed ? roleIsAtLeast(parsed, "organizer") : false;
}
